// Admin / impersonation erişim yardımcıları.
// "Health Checks" gibi yalnızca (a) super_admin login veya (b) admin impersonation
// oturumlarında görünmesi gereken alanlar için ortak kapı.

import { CLIENT_ROLES } from "@routebot/constants";

/** Admin panelinden kullanıcı taklidi (impersonation) aktif mi? */
export function isAdminImpersonationSession() {
  try {
    return localStorage.getItem("isImpersonating") === "true" && !!localStorage.getItem("adminClientData");
  } catch {
    return false;
  }
}

/** super_admin olarak login mi? */
export function isSuperAdmin(auth) {
  return auth?.client?.role === CLIENT_ROLES.SUPER_ADMIN;
}

/** super_admin login VEYA admin impersonation → true. Normal kullanıcı → false. */
export function isAdminOrImpersonating(auth) {
  return isSuperAdmin(auth) || isAdminImpersonationSession();
}
